import { Component, inject, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { AuthenticationService } from '@lib-ui/lib/services';

@Component({
  selector: 'lib-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  standalone: true,
})
export class LogoutComponent implements OnInit {
  private authenticationService = inject(AuthenticationService);

  public ngOnInit() {
    this.authenticationService.logout().pipe(take(1)).subscribe();
  }
}
